import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { dataGridSx } from '../../common/styled/DataGrid';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const LCReportTable = ({ lcReportData }: { lcReportData: any }) => {
  const uniqueKeys = tableColumnUtils.extractUniqueKeys(lcReportData);

  const dynamicColumns: GridColDef[] =
    tableColumnUtils.createColumnsFromKeys(uniqueKeys);
  
  const columnsToDisplay: GridColDef[] =
    tableColumnUtils.getColumnsToDisplay(dynamicColumns);

  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={lcReportData}
        columns={columnsToDisplay}
        getRowId={(row) => row.id}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        columnVisibilityModel={{
          id: false,
          studentId: false,
          createdBy: false
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default LCReportTable;
